import useCommonModal from '@/compositions/useCommonModal';
import { useMutation } from '@vue/apollo-composable';
import schemaGql from './item.graphql';

const useFragmentActions = (props, context, entity) => {
  const modalComposition = useCommonModal();

  const { mutate: copyAndLink } = useMutation(schemaGql.copyAndLink);
  const { mutate: updateSchema } = useMutation(schemaGql.update);
  const { mutate: deleteSchema } = useMutation(schemaGql.deleteSchema);

  const editSchema = targetEntity => {
    modalComposition.modal.show({
      component: () => import('@/components/app-entity/modals/AppDialog.vue'),
      bind: {
        nameModal: 'EditSchema'
      },
      slots: {
        default: {
          component: () => import('@/router/routes/schemas/edit/index'),
          bind: {
            entity: targetEntity
          },
          on: {
            'update-table'() {},
            close() {
              modalComposition.modal.hide('EditSchema');
            },
            save() {
              entity.lazyQuery.restart();
            }
          }
        }
      }
    });
  };

  const copyAndLinkSchema = targetEntity => {
    copyAndLink({
      input: {
        linkToSchemaId: props.id,
        schemaId: targetEntity.id,
        newSchemaName: `${targetEntity.name} copy`
      }
    });
  };

  const copyToClipboard = targetEntity => {
    context.root.$copyText(targetEntity.id).catch(err => {
      console.error(`Cannot copy: ${err}`);
    });
  };

  const unLinkSchema = targetEntity => {
    updateSchema({
      input: {
        id: targetEntity.id,
        patch: {
          parentSchemaId: null
        }
      }
    });
  };

  const handleDeleteSchema = targetEntity => {
    modalComposition.modal.show({
      component: () => import('@/components/app-entity/modals/AppDialog.vue'),
      bind: {
        nameModal: 'DeleteSchema'
      },
      slots: {
        default: {
          component: () =>
            import('@/components/app-entity/modals/DefaultConfirmation'),
          bind: {
            textDelete: 'Delete this schema completely?'
          },
          on: {
            delete() {
              deleteSchema({
                input: {
                  id: targetEntity.id
                }
              }).then(() => {
                modalComposition.modal.hide('DeleteSchema');
              });
            },
            close() {
              modalComposition.modal.hide('DeleteSchema');
            }
          }
        }
      }
    });
  };

  const getActions = targetEntity => {
    return [
      {
        id: 'EditSchema',
        text: 'Edit',
        icon: 'mdi-pencil',
        handleAction: () => editSchema(targetEntity),
        _enabled: true
      },
      {
        id: 'CopyLink',
        text: 'Copy & Link',
        icon: 'mdi-content-copy',
        handleAction: () => copyAndLinkSchema(targetEntity),
        _enabled: true
      },
      {
        id: 'copy',
        text: 'Copy UUID',
        icon: 'mdi-content-copy',
        handleAction: () => copyToClipboard(targetEntity),
        _enabled: true
      },
      {
        id: 'UnlinkSchema',
        text: 'Unlink',
        icon: 'mdi-reply',
        handleAction: () => unLinkSchema(targetEntity),
        _enabled: true
      },
      {
        id: 'DeleteSchema',
        text: 'Delete',
        icon: 'mdi-delete',
        handleAction: () => handleDeleteSchema(targetEntity),
        _enabled: true
      }
    ];
  };
  return {
    getActions
  };
};

export default useFragmentActions;
